import { Army, ARMY_CONFIG } from '../armyConfig';

export function getArmyDisplayName(army: Army | undefined): string {
  if (!army) return '';
  
  const config = ARMY_CONFIG[army];
  const faction = config.faction;
  
  // Count how many armies are in this faction
  const armiesInFaction = Object.values(ARMY_CONFIG).filter(a => a.faction === faction);
  
  if (armiesInFaction.length === 1) {
    return faction;
  }
  
  return `${faction} (${config.name})`;
}

// Smart display for triggers: prefer shortName/shortArmyName if long
export function getArmyTriggerDisplayName(army: Army | undefined): string {
  if (!army) return '';
  const config = ARMY_CONFIG[army];
  const fullName = getArmyDisplayName(army);
  if (fullName.length <= 25) return fullName;
  // Try shortName + shortArmyName
  if (config.shortArmyName) return `${config.shortName} (${config.shortArmyName})`;
  // Try shortName + full army name
  if (config.shortName && config.name.length <= 18) return `${config.shortName} (${config.name})`;
  // Try full faction + shortArmyName
  if (config.shortArmyName) return `${config.faction} (${config.shortArmyName})`;
  // Fallback to full name
  return fullName;
} 